module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewership-time-frame"
  }, [_c('div', {
    staticClass: "viewership-time-frame__label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "viewership-time-frame__value",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedText) + " "), _c('svg-icon', {
    attrs: {
      "icon": _vm.arrow,
      "width": 12,
      "height": 8
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-658601e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/audienceSize/ViewershipTimeFrame.vue
// module id = 1920
// module chunks = 0